export const config = {
  apiKey: "AIzaSyDHVNfJDTWnuDlFGvu8NO8vd7UJ3UTWO5I",
  authDomain: "vechain.firebaseapp.com",
  databaseURL: "https://vechain.firebaseio.com",
  projectId: "vechain",
  storageBucket: "vechain.appspot.com",
  messagingSenderId: "780152396188"
};
